import React from 'react';
import WidgetInfoSettings from '../../settings_sidebar/WidgetInfoSettings.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';

function ApplicantProjectListWidgetSettings({widgetId}) {
    
    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <WidgetInfoSettings widgetId={widgetId} />
        </CollapsibleSection>
    </>);

};
export default ApplicantProjectListWidgetSettings;